import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/en/solutions/detail/$slug")({
  head: ({ params }) => buildRouteHead(`/en/solutions/detail/${params.slug}`),
  component: SolutionDetail,
});

